<div class="dialog-root">
  <div class="dialog-header">
    <div>
      <h2 mat-dialog-title class="dialog-title">Kritikus pontok ellenőrzése</h2>
      <div class="dialog-subtitle">
        AI alapú minőségellenőrzés az aktuális útvonal kritikus pontjaira
      </div>
    </div>

    <div
      class="status-pill"
      [class.status-pill--ok]="failedChecks.length === 0"
      [class.status-pill--error]="failedChecks.length > 0"
    >
      {{ failedChecks.length === 0 ? "Nincs hiba" : "Hibák találhatók" }}
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-label">Ellenőrzött pontok</div>
        <div class="stat-value">{{ data.checks.length }}</div>
      </div>

      <div class="stat-card stat-card--success">
        <div class="stat-label">Megfelelő</div>
        <div class="stat-value">{{ successfulChecksCount }}</div>
      </div>

      <div class="stat-card stat-card--error">
        <div class="stat-label">Hibás</div>
        <div class="stat-value">{{ failedChecks.length }}</div>
      </div>
    </div>

    <div class="meta-card">
      <div class="meta-item">
        <span class="meta-label">Workflow</span>
        <span class="meta-value mono">{{ data.workflowId }}</span>
      </div>
      <div class="meta-item">
        <span class="meta-label">Útvonal</span>
        <span class="meta-value mono">{{ data.practicePathUuid }}</span>
      </div>
    </div>

    <div *ngIf="failedChecks.length === 0" class="all-ok-state">
      <mat-icon>task_alt</mat-icon>
      <span>Minden kritikus pont megfelelt az ellenőrzésen.</span>
    </div>

    <div *ngIf="failedChecks.length > 0" class="failed-items-container">
      <div class="failed-item" *ngFor="let failedCheck of failedChecks">
        <div class="failed-item-header">
          <div class="failed-item-title-group">
            <span class="failed-item-title">{{ failedCheck.criticalPointTitle }}</span>
            <span class="failed-item-uuid mono">{{ failedCheck.criticalPointUuid }}</span>
          </div>
          <span class="issue-badge">Hibás</span>
        </div>
        <div class="failed-item-reason">
          {{ failedCheck.reason || "Nincs részletes indoklás." }}
        </div>
        <div class="failed-item-actions">
          <button
            mat-flat-button
            color="primary"
            (click)="onTapOpenCriticalPoint(failedCheck.criticalPointUuid)"
          >
            <mat-icon>open_in_new</mat-icon>
            Kritikus pont megnyitása
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-stroked-button mat-dialog-close>Bezárás</button>
  </mat-dialog-actions>
</div>
